function ProgressBar({ current, total, percent }) {
  return (
    <div className="mb-6">
      <div className="mb-2 flex items-center justify-between text-sm text-gray-500">
        <span>
          第 {current} 题 / 共 {total} 题
        </span>
        <span>{percent}%</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-gray-200">
        <div
          className="h-full bg-fox-orange transition-all duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;
